module.exports = __webpack_public_path__ + "static/img_reward_01@2x-8db411dd6908158deda6c4eac6e54bdb.png";